import { SetStateAction, useContext } from "react";

import { useTranslation } from "react-i18next";

import AlertContext from "context/alert/alertContext";
import AuthContext from "context/auth/authContext";
import ParamsContext from "context/params/paramsContext";
import TableContext from "context/table/tableContext";
import TriSourceContext from "context/triSource/triSourceContext";
import { useApi } from "shared/hooks/useApi";
import { ENDPOINTS, TABLE_NAMES } from "shared/types/enums";

const useTriSourceAction = () => {
    const { setAlert, setBackgroundActionId } = useContext(AlertContext);
    const { rootCompany, setReloadItems } = useContext(ParamsContext);
    const { isSupportUser, isSuperUser } = useContext(AuthContext);
    const { columns, deselectAllRows } = useContext(TableContext);

    const { activeSource, sourcePayload, isSourceReady, isSelectedSingleItem } =
        useContext(TriSourceContext);

    const { t } = useTranslation();

    const {
        postData,
        bulkPostData,
        updateData,
        bulkUpdateData,
        handleResponse
    } = useApi();

    const updateDevices = async (
        payloadData: any,
        setLoading: (value: SetStateAction<boolean>) => void,
        closeDialog: () => void
    ) => {
        const deselectAndClose = () => {
            deselectAllRows();
            closeDialog();
        };

        try {
            setLoading(true);

            const response = await (isSelectedSingleItem
                ? updateData(
                      ENDPOINTS.Devices,
                      (sourcePayload as number[])[0],
                      payloadData
                  )
                : bulkUpdateData(ENDPOINTS.Devices, payloadData));

            if (isSelectedSingleItem) {
                deselectAndClose();
                handleResponse(response);
            } else {
                setBackgroundActionId(
                    response.data,
                    TABLE_NAMES.Devices,
                    () => {
                        deselectAndClose();
                        setReloadItems(TABLE_NAMES.Devices);
                    },
                    () => setLoading(false)
                );
            }
        } catch (error) {
            handleResponse(error);
            setLoading(false);
        }
    };

    return {
        t,
        rootCompany,
        isSupportUser,
        isSuperUser,
        columns,
        activeSource,
        sourcePayload,
        isSourceReady,
        isSelectedSingleItem,
        setAlert,
        setBackgroundActionId,
        deselectAllRows,
        postData,
        bulkPostData,
        updateData,
        bulkUpdateData,
        handleResponse,
        updateDevices
    };
};

export { useTriSourceAction };
